export const MAX_NUMBER_OF_DAYS = 31;

export const getDaysInMonth = (month?: number, year?: number) => {
  if (month && year) {
    return new Date(year, month, 0).getDate();
  }
  return MAX_NUMBER_OF_DAYS;
};
